import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
} from 'redux-saga/effects';
import { taskManagementActions as actions, notificationActions } from '../actions';
import { taskManagementService } from '../services';

/* Add Task */
function* handleAddTaskRequest() {
    const action = yield take(actions.addTaskRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.addTask, dataParams)
        if (res.isError) {
            yield put(actions.addTaskError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addTaskSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addTaskError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Department */
function* handleGetAllTaskRequest() {
    const action = yield take(actions.getAllTaskRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.getAllTask, dataParams);

        if (res.isError) {
            yield put(actions.getAllTaskError(res));

        } else {
            yield put(actions.getAllTaskSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllTaskError());
    }
}

/* Update Task */
function* handleUpdateTaskRequest() {
    const action = yield take(actions.updateTaskRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.updateTask, dataParams);
        if (res.isError) {
            yield put(actions.updateTaskError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateTaskSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateTaskError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Delete Task */
function* handleDeleteTaskRequest() {
    const action = yield take(actions.deleteTaskRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.deleteTask, dataParams);
        if (res.isError) {
            yield put(actions.deleteTaskError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteTaskSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteTaskError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Add Sub Task */
function* handleAddSubTaskRequest() {
    const action = yield take(actions.addSubTaskRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.addSubTask, dataParams)
        if (res.isError) {
            yield put(actions.addSubTaskError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addSubTaskSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addSubTaskError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Sub Task */
function* handleGetAllSubTaskRequest() {
    const action = yield take(actions.getAllSubTaskRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.getAllSubTask, dataParams);

        if (res.isError) {
            yield put(actions.getAllSubTaskError(res));

        } else {
            yield put(actions.getAllSubTaskSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllSubTaskError());
    }
}

/* Update Sub Task */
function* handleUpdateSubTaskRequest() {
    const action = yield take(actions.updateSubTaskRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.updateSubTask, dataParams);
        if (res.isError) {
            yield put(actions.updateSubTaskError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateSubTaskSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateSubTaskError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Delete Sub Task */
function* handleDeleteSubTaskRequest() {
    const action = yield take(actions.deleteSubTaskRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.deleteSubTask, dataParams);
        if (res.isError) {
            yield put(actions.deleteSubTaskError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteSubTaskSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteSubTaskError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* create Task Project Sagas */
function* handleAddTaskProjectRequest() {
    const action = yield take(actions.addTaskProjectRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.addTaskProject, dataParams);
        if (res.isError) {
            yield put(actions.addTaskProjectError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addTaskProjectSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addTaskProjectError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Task Project Sagas*/
function* handleGetTaskProjectRequest() {
    const action = yield take(actions.getTaskProjectRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.getTaskProject, dataParams);

        if (res.isError) {
            yield put(actions.getTaskProjectError(res));

        } else {
            yield put(actions.getTaskProjectSuccess(res));
        }

    } catch (error) {
        yield put(actions.getTaskProjectError());
    }
}

/* Get All Sub Department List Sagas*/
function* handleGetAllTaskProjectListRequest() {
    const action = yield take(actions.getAllTaskProjectListRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.getAllTaskProjectList, dataParams);

        if (res.isError) {
            yield put(actions.getAllTaskProjectListError(res));

        } else {
            yield put(actions.getAllTaskProjectListSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllTaskProjectListError());
    }
}

/* Update Sub Department Sagas */
function* handleUpdateTaskProjectRequest() {
    const action = yield take(actions.updateTaskProjectRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.updateTaskProject, dataParams);
        if (res.isError) {
            yield put(actions.updateTaskProjectError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateTaskProjectSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateTaskProjectError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}
/* Delete Task Project Sagas */
function* handleDeleteTaskProjectRequest() {
    const action = yield take(actions.deleteTaskProjectRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.deleteTaskProject, dataParams);
        if (res.isError) {
            yield put(actions.deleteTaskProjectError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteTaskProjectSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteTaskProjectError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/*Save Time Tracking Sagas */
function* handleSaveTimeTrackingRequest() {
    const action = yield take(actions.saveTimeTrackingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.saveTimeTracking, dataParams);
        if (res.isError) {
            yield put(actions.saveTimeTrackingError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.saveTimeTrackingSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.saveTimeTrackingError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/*Save Time Tracking Sagas */
function* handleGetTaskLogsRequest() {
    const action = yield take(actions.getTaskLogsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.getTaskLogs, dataParams);
        if (res.isError) {
            yield put(actions.getTaskLogsError(res));

        } else {
            yield put(actions.getTaskLogsSuccess(res));

        }
    } catch (error) {
        yield put(actions.getTaskLogsError());

    }
}

/*Save Time Tracking Sagas */
function* handleTaskReportRequest() {
    const action = yield take(actions.taskReportRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.taskReport, dataParams);
        if (res.isError) {
            yield put(actions.taskReportError(res));

        } else {
            yield put(actions.taskReportSuccess(res));

        }
    } catch (error) {
        yield put(actions.taskReportError());

    }
}

/*Task Status Sagas */
function* handleTaskStatusRequest() {
    const action = yield take(actions.taskStatusRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.taskStatus, dataParams);
        if (res.isError) {
            yield put(actions.taskStatusError(res));

        } else {
            yield put(actions.taskStatusSuccess(res));

        }
    } catch (error) {
        yield put(actions.taskStatusError());

    }
}

/* Employee Wise Task Sagas */
function* handleEmployeeWiseTaskRequest() {
    const action = yield take(actions.employeeWiseTaskRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.employeeWiseTask, dataParams);
        if (res.isError) {
            yield put(actions.employeeWiseTaskError(res));

        } else {
            yield put(actions.employeeWiseTaskSuccess(res));

        }
    } catch (error) {
        yield put(actions.employeeWiseTaskError());

    }
}

/* Task Graph Sagas */
function* handleTaskGraphRequest() {
    const action = yield take(actions.taskGraphRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.taskGraph, dataParams);
        if (res.isError) {
            yield put(actions.taskGraphError(res));

        } else {
            yield put(actions.taskGraphSuccess(res));

        }
    } catch (error) {
        yield put(actions.taskGraphError());
    }
}

/* Change Status Sagas */
function* handleChangeStatusRequest() {
    const action = yield take(actions.changeStatusRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.changeStatus, dataParams);
        if (res.isError) {
            yield put(actions.changeStatusError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

        } else {
            yield put(actions.changeStatusSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));

        }
    } catch (error) {
        yield put(actions.changeStatusError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Change Due Date Sagas */
function* handleChangeDueDateRequest() {
    const action = yield take(actions.changeDueDateRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.changeDueDate, dataParams);
        if (res.isError) {
            yield put(actions.changeDueDateError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

        } else {
            yield put(actions.changeDueDateSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));

        }
    } catch (error) {
        yield put(actions.changeDueDateError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Add Task File Graph Sagas */
function* handleAddTaskFileRequest() {
    const action = yield take(actions.addTaskFileRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.addTaskFile, dataParams);
        if (res.isError) {
            yield put(actions.addTaskFileError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

        } else {
            yield put(actions.addTaskFileSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addTaskFileError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Add Task File Graph Sagas */
function* handleGetTaskFileRequest() {
    const action = yield take(actions.getTaskFileRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.getTaskFile, dataParams);
        if (res.isError) {
            yield put(actions.getTaskFileError(res));

        } else {
            yield put(actions.getTaskFileSuccess(res));

        }
    } catch (error) {
        yield put(actions.getTaskFileError());
    }
}



/* Sub Task Status Sagas */
function* handleSubTaskStatusRequest() {
    const action = yield take(actions.subTaskStatusRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.subTaskStatus, dataParams);
        if (res.isError) {
            yield put(actions.subTaskStatusError(res));

        } else {
            yield put(actions.subTaskStatusSuccess(res));

        }
    } catch (error) {
        yield put(actions.subTaskStatusError());
    }
}

/* Sub Task Status Sagas */
function* handleGetMyTaskRequest() {
    const action = yield take(actions.getMyTaskRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(taskManagementService.getMyTask, dataParams);
        if (res.isError) {
            yield put(actions.getMyTaskError(res));

        } else {
            yield put(actions.getMyTaskSuccess(res));

        }
    } catch (error) {
        yield put(actions.getMyTaskError());
    }
}


/* -----------Watchers-------------*/
function* handleAddTaskWatcher() {
    yield takeEvery(
        actions.addTaskRequest,
        handleAddTaskRequest,
    );
}

function* handleGetAllTaskWatcher() {
    yield takeEvery(
        actions.getAllTaskRequest,
        handleGetAllTaskRequest,
    );
}

function* handleUpdateTaskWatcher() {
    yield takeEvery(
        actions.updateTaskRequest,
        handleUpdateTaskRequest,
    );
}

function* handleDeleteTaskWatcher() {
    yield takeEvery(
        actions.deleteTaskRequest,
        handleDeleteTaskRequest,
    );
}

function* handleAddSubTaskWatcher() {
    yield takeEvery(
        actions.addSubTaskRequest,
        handleAddSubTaskRequest,
    );
}

function* handleGetAllSubTaskWatcher() {
    yield takeEvery(
        actions.getAllSubTaskRequest,
        handleGetAllSubTaskRequest,
    );
}

function* handleUpdateSubTaskWatcher() {
    yield takeEvery(
        actions.updateSubTaskRequest,
        handleUpdateSubTaskRequest,
    );
}

function* handleDeleteSubTaskWatcher() {
    yield takeEvery(
        actions.deleteSubTaskRequest,
        handleDeleteSubTaskRequest,
    );
}

function* handleSubTaskStatusWatcher() {
    yield takeEvery(
        actions.subTaskStatusRequest,
        handleSubTaskStatusRequest,
    );
}

function* handleAddTaskProjectWatcher() {
    yield takeEvery(
        actions.addTaskProjectRequest,
        handleAddTaskProjectRequest,
    );
}

function* handleGetTaskProjectWatcher() {
    yield takeEvery(
        actions.getTaskProjectRequest,
        handleGetTaskProjectRequest,
    );
}

function* handleGetAllTaskProjectListWatcher() {
    yield takeEvery(
        actions.getAllTaskProjectListRequest,
        handleGetAllTaskProjectListRequest,
    );
}

function* handleUpdateTaskProjectWatcher() {
    yield takeEvery(
        actions.updateTaskProjectRequest,
        handleUpdateTaskProjectRequest,
    );
}

function* handleDeleteTaskProjectWatcher() {
    yield takeEvery(
        actions.deleteTaskProjectRequest,
        handleDeleteTaskProjectRequest,
    );
}

function* handleSaveTimeTrackingWatcher() {
    yield takeEvery(
        actions.saveTimeTrackingRequest,
        handleSaveTimeTrackingRequest,
    );
}

function* handleGetTaskLogsWatcher() {
    yield takeEvery(
        actions.getTaskLogsRequest,
        handleGetTaskLogsRequest,
    );
}

function* handleTaskReportWatcher() {
    yield takeEvery(
        actions.taskReportRequest,
        handleTaskReportRequest,
    );
}

function* handleTaskStatusWatcher() {
    yield takeEvery(
        actions.taskStatusRequest,
        handleTaskStatusRequest,
    );
}

function* handleEmployeeWiseTaskWatcher() {
    yield takeEvery(
        actions.employeeWiseTaskRequest,
        handleEmployeeWiseTaskRequest,
    );
}

function* handleTaskGraphWatcher() {
    yield takeEvery(
        actions.taskGraphRequest,
        handleTaskGraphRequest,
    );
}

function* handleChangeStatusWatcher() {
    yield takeEvery(
        actions.changeStatusRequest,
        handleChangeStatusRequest,
    );
}

function* handleChangeDueDateWatcher() {
    yield takeEvery(
        actions.changeDueDateRequest,
        handleChangeDueDateRequest,
    );
}

function* handleAddTaskFileWatcher() {
    yield takeEvery(
        actions.addTaskFileRequest,
        handleAddTaskFileRequest,
    );
}


function* handleGetTaskFileWatcher() {
    yield takeEvery(
        actions.getTaskFileRequest,
        handleGetTaskFileRequest,
    );
}

function* handleGetMyTaskWatcher() {
    yield takeEvery(
        actions.getMyTaskRequest,
        handleGetMyTaskRequest,
    );
}




function* rootTaskManagementSaga() {
    yield all([
        handleAddTaskRequest(),
        handleAddTaskWatcher(),

        handleGetAllTaskRequest(),
        handleGetAllTaskWatcher(),

        handleUpdateTaskRequest(),
        handleUpdateTaskWatcher(),

        handleDeleteTaskRequest(),
        handleDeleteTaskWatcher(),

        handleAddSubTaskRequest(),
        handleAddSubTaskWatcher(),

        handleGetAllSubTaskRequest(),
        handleGetAllSubTaskWatcher(),

        handleUpdateSubTaskRequest(),
        handleUpdateSubTaskWatcher(),

        handleDeleteSubTaskRequest(),
        handleDeleteSubTaskWatcher(),

        handleAddTaskProjectRequest(),
        handleAddTaskProjectWatcher(),

        handleGetTaskProjectRequest(),
        handleGetTaskProjectWatcher(),

        handleGetAllTaskProjectListRequest(),
        handleGetAllTaskProjectListWatcher(),

        handleUpdateTaskProjectRequest(),
        handleUpdateTaskProjectWatcher(),

        handleDeleteTaskProjectRequest(),
        handleDeleteTaskProjectWatcher(),

        handleSaveTimeTrackingRequest(),
        handleSaveTimeTrackingWatcher(),

        handleGetTaskLogsRequest(),
        handleGetTaskLogsWatcher(),

        handleTaskReportRequest(),
        handleTaskReportWatcher(),

        handleTaskStatusRequest(),
        handleTaskStatusWatcher(),

        handleEmployeeWiseTaskRequest(),
        handleEmployeeWiseTaskWatcher(),

        handleTaskGraphRequest(),
        handleTaskGraphWatcher(),

        handleChangeStatusRequest(),
        handleChangeStatusWatcher(),

        handleChangeDueDateRequest(),
        handleChangeDueDateWatcher(),

        handleAddTaskFileRequest(),
        handleAddTaskFileWatcher(),

        handleGetTaskFileRequest(),
        handleGetTaskFileWatcher(),


        handleSubTaskStatusRequest(),
        handleSubTaskStatusWatcher(),

        handleGetMyTaskRequest(),
        handleGetMyTaskWatcher(),
    ]);
}

export default rootTaskManagementSaga;
